import {apolloClient} from 'shared/apollo'
import deleteSessionNotificationSubscriptionMutation from 'shared/graphql/deleteSessionNotificationSubscription.gql'
import querySession from 'shared/graphql/querySession.gql'

export default function deleteSessionNotificationSubscription({userId, sessionId}) {
	return apolloClient.mutate({
		mutation: deleteSessionNotificationSubscriptionMutation,
		variables: {
			userId,
			sessionId,
		},
		update(cache, response) {
			if (!response.data.delete_session_notification_subscriptions_by_pk) {
				throw new Error(`It was not possible to delete this session subscription.`)
			}

			const variables = {id: sessionId, userId, isUserWorkspaceMember: true}
			let data = cache.readQuery({query: querySession, variables})
			if (!data?.session) return

			data = JSON.parse(JSON.stringify(data))
			data.session.notificationSubscriptions = data.session.notificationSubscriptions.filter(
				userSubscription => userSubscription.userId !== userId
			)

			cache.writeQuery({query: querySession, variables, data})
		},
		optimisticResponse: {
			delete_session_notification_subscriptions_by_pk: {
				__typename: 'session_user_subscription',
				userId,
				sessionId,
			},
		},
	})
}
